<template>
  <div>
    <HeadTab isshow="0"></HeadTab>
    <!-- 中间内容 -->
    <div class="minu">
      <div>
        <img class="minu_img" src="../../static/img/Ir.png" alt="" />
        <div class="minu_title">На рассмотрении</div>
        <div class="minu_text">Ваша заявка подана, пожалуйста, зайдите в приложение, чтобы проверить сумму</div>
        <div class="minu_btn" @click="appstoreFn">
          <img class="minu_btn-img" src="/static/img/google-play-badge.png" alt="" />
          <div class="">Получить</div>
        </div>
      </div>
    </div>
    <!-- 底部协议 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>

<script>
  import BomTab from '@/components/BomTab.vue'
  import HeadTab from '@/components/HeadTab.vue'
  export default {
    name: "underreview",
      data() {
        return {

        }
      },
      components: {
        BomTab,
        HeadTab
      },
      methods: {
        appstoreFn() {
          this.$message({
            message: 'В стадии разработки'
          });
        },
        quit(){
          localStorage.clear();
          this.$router.push('/')
        }
      }
    }
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    border: none;
    Outline: none;
  }

  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.25rem;
    height: 0.19rem;
    margin-right: 0.07rem;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
    cursor: pointer;
  }
  .headAbout_textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #999999;
    font-style: normal;
    cursor: pointer;
  }
  .headAbout_textTwo:hover{
    color: #06B804;
    cursor: pointer;
  }

  .minu {
    border-top: 0.01rem solid #C0C0C0;
    padding-top: 1.56rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.67rem;
    text-align: center;
  }
  .minu_img{
    width: 0.78rem;
    height: 0.78rem;
    margin-bottom: 0.21rem;
  }
  .minu_title{
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .minu_text{
    width: 2.18rem;
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.06rem;
    color: #333333;
    font-style: normal;
    margin: 0 auto 0.26rem;
  }
  .minu_btn{
    width: 2.81rem;
    height: 0.29rem;
    line-height: 0.29rem;
    background: #F04B23;
    border-radius: 0.04rem;
    text-align: center;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .minu_btn-img{
    width: 0.53rem;
    height: 0.16rem;
    margin-right: 0.14rem;
  }

  /* 底部 */
  .bom {
    background: #F9F9F9;
    padding: 0.52rem 1.88rem;
  }

  .bom_con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.31rem;
  }

  .bom_con-text {
    width: 2.76rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
  }

  .bom_minuIm {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_con-num {
    width: 1.1rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.15rem;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
    cursor: pointer;
  }
  .bom_mi{
    display: flex;
    flex-direction: row;
  }
  .bom_mi-text{
    width: 1.78rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.4rem;
  }
  .bom_mi-tit{
    width: 4rem;
    height: 0.38rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/underreview.vue